import {IHttpService} from "angular";
import {ChessRegistrationDetailRecords} from "../types/ChessRegistrationDetailRecord";
import {AccountId} from "../types/AccountRecord";

export class ChessRegistrationDetailsService {

    public static readonly id = "chessRegistrationDetailsService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {
    }

    public async detail(accountId: AccountId): Promise<ChessRegistrationDetailRecords> {
        const url = `/tradefloor/api/chess-registration-detail/${accountId}`;
        const params = { };
        const response = await this.$http.get<ChessRegistrationDetailRecords>(url, params);
        return response.data;
    }
}